// extracted by mini-css-extract-plugin
export default {"root":"sU06w","icon":"YxgKv","unreadCircle":"f79oc"};